import {type RouteConfigType} from './route-config-type';

/**
 * While phasing out the Ember Router we have to keep this common config that both routers refer to.
 * This is due to Ember not letting any traffic through to routes it doesn't know about
 */
export const RouteConfig = {
    welcome: {path: '/welcome/:token', crew: 'foundation'},
    invitation: {
        path: '/invitation',
        subRoutes: {
            challenge: {
                path: '/:roleInvitationId',
                crew: 'foundation',
            },
            accepted: {
                path: '/accepted',
                crew: 'foundation',
            },
            denied: {
                path: '/denied',
                crew: 'foundation',
            },
        },
        crew: 'foundation',
    },
    famlyLiveJoinMeeting: {path: '/famlyLive/joinMeeting', crew: 'ptp'},
    famlyLiveMeetingLeft: {path: '/famlyLiveMeetingLeft', crew: 'ptp'},
    forgotPassword: {path: '/forgotPassword', crew: 'foundation'},
    signup: {path: '/signup', crew: 'growth'},
    debugger: {
        path: '/debugger',
        crew: 'foundation',
        subRoutes: {
            loginWithAccessToken: {
                path: '/loginWithAccessToken',
                crew: 'foundation',
            },
        },
    },
    icons: {path: '/icons', crew: 'foundation'},
    inquiry: {path: '/inquiry', crew: 'stat'},
    contextChallenge: {path: '/contextChallenge', crew: 'foundation'},
    testLogin: {path: '/testLogin', crew: 'foundation'},
    errorTest: {path: '/errorTest', crew: 'foundation'},
    errorLog: {path: '/errorLog', crew: 'foundation'},
    connectTokenSent: {path: '/connectTokenSent', crew: 'foundation'},
    resetPassword: {path: '/resetPassword', crew: 'foundation'},
    oneTimeLogin: {path: '/one-time-login', crew: 'foundation'},
    confirmEmail: {path: '/confirmEmail', crew: 'foundation'},
    newAccount: {path: '/newAccount', crew: 'foundation'},
    notFound: {path: '/notFound', crew: 'foundation'},
    customInquiryForm: {
        path: '/customInquiryForm/:formId/to/:siteSetId',
        crew: 'stat',
        subRoutes: {
            // Private route
            preview: {
                path: '/preview',
                crew: 'stat',
            },
            // Public route
            submit: {
                path: '/submit',
                crew: 'stat',
            },
        },
    },
    tooManyFailedLoginAttempts: {
        path: '/tooManyFailedLoginAttempts',
        crew: 'foundation',
    },
    contract: {path: '/contract', crew: 'foundation'},
    unavailable: {path: '/unavailable', crew: 'foundation'},
    login: {path: '/login', crew: 'foundation'},
    offer: {path: '/offer/:id', crew: 'growth'},
    emailVerification: {
        path: '/emailVerification/:verificationCode/to/:siteSetId',
        crew: 'foundation',
    },
    newSiteRequest: {path: '/newSiteRequest', crew: 'growth'},

    // Open id
    openid: {
        path: '/openid',
        crew: 'foundation',
        subRoutes: {
            // Route used as callback when authenticating with an OIDC provider
            redirect: {
                path: '/redirect',
                crew: 'foundation',
            },
            // Used for connecting a Famly account with an OIDC account
            connect: {
                path: '/connect',
                crew: 'foundation',
            },
            // Route used as callback when connecting your a Famly account with an OIDC account
            connectCallback: {
                path: '/connectCallback',
                crew: 'foundation',
            },
            // Used for authenticating with a token - used for e.g. changing pin codes (for OIDC users)
            tokenCallback: {
                path: '/tokenCallback',
                crew: 'foundation',
            },
        },
    },

    /*
    |---------------------------------------------------------------------------------
    | Account routes
    |---------------------------------------------------------------------------------
    */
    account: {
        path: '/account',
        crew: 'foundation',
        subRoutes: {
            event: {path: '/event/:eventId', crew: 'ptp'},
            newWeekPlan: {path: '/newWeekPlan', crew: 'ptp'},
            calendar: {
                path: '/calendar',
                crew: 'ptp',
                subRoutes: {
                    me: {path: '/me', crew: 'ptp'},
                },
            },
            activities: {
                path: '/activities',
                crew: 'ptp',
                subRoutes: {
                    library: {path: '/library/:libraryId', crew: 'ptp'},
                    activity: {path: '/activity/:id', crew: 'ptp'},
                },
            },
            inbox: {path: '/inbox', crew: 'ptp'},
            dataExports: {path: '/dataExports', crew: 'foundation'},
            moreMenu: {path: '/moreMenu', crew: 'foundation'},
            navigationV2MobileMenu: {
                path: '/navigationV2MobileMenu',
                crew: 'foundation',
                subRoutes: {
                    navigationGroup: {
                        path: '/navigationGroup/:groupId',
                        crew: 'foundation',
                    },
                },
            },
            billingOverview: {path: '/billingOverview', crew: 'finance'},
            post: {
                path: '/post/:postId',
                crew: 'ptp',
                subRoutes: {
                    comments: {path: '/comments', crew: 'ptp'},
                },
            },
            // Legacy route for keeping links in notification emails working
            posts: {
                path: '/posts/:postId',
                crew: 'ptp',
                subRoutes: {
                    comments: {path: '/comments', crew: 'ptp'},
                },
            },
            parentHome: {
                crew: 'stat',
                path: '/home',
                subRoutes: {
                    explore: {
                        path: '/explore',
                        crew: 'stat',
                    },
                    resourceCategories: {
                        path: '/resourceCategories/:resourceCategoryName',
                        crew: 'enr',
                    },
                    resource: {
                        path: '/resources/:resourceId',
                        crew: 'enr',
                    },
                },
            },
            feed: {
                path: '/feed',
                crew: 'ptp',
                subRoutes: {
                    me: {path: '/me', crew: 'ptp'},
                    bookmarks: {path: '/bookmarks', crew: 'ptp'},
                },
            },
            // Lesson plans parent route
            lessonPlans: {path: '/lessonPlans', crew: 'ptp'},
            notifications: {path: '/notifications', crew: 'foundation'},
            balances: {path: '/balances/:loginId', crew: 'finance'},
            previousChildren: {path: '/previousChildren', crew: 'foundation'},
            childVacationReply: {
                path: '/childVacationReply/:vacationId',
                crew: 'stat',
            },
            openid: {
                path: '/openid',
                crew: 'foundation',
                subRoutes: {connect: {path: '/connect', crew: 'foundation'}},
            },
            childProfile: {
                path: '/childProfile/:childId',
                crew: 'foundation',
                subRoutes: {
                    activity: {path: '/activity', crew: 'ptp'},
                    about: {path: '/about', crew: 'foundation'},
                    sleep: {path: '/sleep', crew: 'ptp'},
                    institutionInfo: {path: '/institutionInfo', crew: 'foundation'},
                    leave: {path: '/leave', crew: 'stat'},
                    photos: {path: '/photos', crew: 'foundation'},
                    childProfilePlans: {path: '/childProfilePlans', crew: 'finance'}, // this route just redirects to /plansAndInvoices
                    childProfileBilling: {
                        path: '/childProfileBilling',
                        crew: 'finance',
                    }, // this route just redirects to /plansAndInvoices
                    childProfileRelations: {
                        path: '/childProfileRelations',
                        crew: 'foundation',
                    },
                    plansAndInvoices: {path: '/plansAndInvoices', crew: 'finance'},
                    childProfileNotes: {
                        path: '/childProfileNotes',
                        crew: 'ptp',
                        subRoutes: {
                            index: {
                                path: '/',
                                crew: 'ptp',
                            },
                            note: {
                                path: '/:noteId',
                                crew: 'ptp',
                            },
                        },
                    },
                    childProfileLearningJourney: {
                        path: '/childProfileLearningJourney',
                        crew: 'ptp',
                        subRoutes: {
                            index: {
                                path: '/',
                                crew: 'ptp',
                            },
                            observation: {
                                path: '/:observationId',
                                crew: 'ptp',
                            },
                        },
                    },
                    childProfileLearningJourneyDetails: {
                        path: '/childProfileLearningJourneyDetails',
                        crew: 'ptp',
                    },
                    safeguarding: {
                        path: '/safeguarding',
                        crew: 'ptp',
                    },
                    family: {
                        path: '/family',
                        crew: 'foundation',
                    },
                    printPreview: {
                        path: '/printPreview',
                        crew: 'growth',
                    },
                },
            },
            settings: {
                path: '/settings',
                crew: 'foundation',
                subRoutes: {
                    customCareGroups: {path: '/customCareGroups/:customCareGroupId', crew: 'stat'},
                    ageGroups: {path: '/ageGroups', crew: 'stat'},
                },
            },
            accountSettings: {
                path: '/accountSettings',
                crew: 'foundation',
                subRoutes: {
                    accountDetails: {path: '/accountDetails', crew: 'foundation'},
                    accountNotifications: {
                        path: '/accountNotifications',
                        crew: 'foundation',
                    },
                    accountPassword: {path: '/accountPassword', crew: 'foundation'},
                    accountPincode: {path: '/accountPincode', crew: 'foundation'},
                    paymentDetails: {path: '/paymentDetails', crew: 'finance'},
                },
            },
            subscription: {path: '/subscription', crew: 'finance'},
            /*
                Since we added Famly Store to the institution routes, the link in the old nav was broken.
                This was due to different way of handling routes and nav links in the old and new nav.
                The solution is to keep both routes (at least for some time) until we are sure, nobody is on the old nav.
            */
            famlyStore: {
                path: '/famlyStore',
                subRoutes: {
                    packagePurchase: {
                        path: '/packagePurchase/:institutionId/:initialPackageId',
                        crew: 'growth',
                    },
                },
                crew: 'growth',
            },
            /*
                Sales to CS flow onboarding tool - customer led self-sign-up after accepting agreed contract (terms of deal)
                Read more about SCS flow here: https://www.notion.so/famly/Sales-to-CS-handover-681a34e59acc47d69f9573a32a41b80e
            */
            scsFlowOnboarding: {
                path: '/scsFlowOnboarding',
                crew: 'growth',
            },

            reports: {
                path: '/reports',
                crew: 'foundation',
                subRoutes: {
                    lists: {
                        path: '/lists',
                        crew: 'foundation',
                        subRoutes: {listFilter: {path: '/list-filter', crew: 'foundation'}},
                    },
                    famlyInsights: {
                        path: '/famlyInsights',
                        crew: 'foundation',
                    },
                    category: {
                        path: '/categories/:categoryId',
                        crew: 'foundation',
                        subRoutes: {
                            report: {
                                path: '/reports/:reportId',
                                crew: 'foundation',
                            },
                        },
                    },
                    report: {
                        path: '/report/:reportId',
                        crew: 'foundation',
                    },
                    new: {
                        path: '/new',
                        crew: 'foundation',
                        subRoutes: {
                            fromDataset: {
                                path: '/fromDataset/:datasetId',
                                crew: 'foundation',
                            },
                            fromReportTemplate: {
                                path: '/fromReportTemplate/:reportTemplateId',
                                crew: 'foundation',
                            },
                        },
                    },
                },
            },
            financeReports: {
                crew: 'foundation',
                path: '/financeReports',
                subRoutes: {
                    report: {
                        crew: 'foundation',
                        path: '/:reportId',
                    },
                },
            },
            learningReports: {
                crew: 'foundation',
                path: '/learningReports',
                subRoutes: {
                    report: {
                        crew: 'foundation',
                        path: '/:reportId',
                    },
                },
            },
            attendanceReports: {
                crew: 'foundation',
                path: '/attendanceReports',
                subRoutes: {
                    report: {
                        crew: 'foundation',
                        path: '/:reportId',
                    },
                },
            },
            /*
            |---------------------------------------------------------------------------------
            | Institution routes
            |---------------------------------------------------------------------------------
            */
            institution: {
                path: '/institution/:institutionId',
                crew: 'foundation',
                subRoutes: {
                    home: {
                        crew: 'foundation',
                        path: '/home',
                    },
                    newStartersOnboarding: {
                        crew: 'stat',
                        path: '/newStartersOnboarding',
                    },
                    homeCustomization: {
                        crew: 'foundation',
                        path: '/customization',
                    },
                    activities: {
                        path: '/activities',
                        crew: 'ptp',
                        subRoutes: {
                            library: {path: '/library/:libraryId', crew: 'ptp'},
                            activity: {path: '/activity/:id', crew: 'ptp'},
                        },
                    },
                    resourceLibrary: {
                        path: '/resourceLibrary',
                        crew: 'enr',
                        subRoutes: {
                            resource: {path: '/resource/:resourceId', crew: 'enr'},
                        },
                    },
                    contractTemplateBuilder: {
                        path: '/contract-template/:templateId',
                        crew: 'enr',
                    },
                    feed: {
                        path: '/feed',
                        crew: 'ptp',
                    },
                    calendar: {
                        path: '/calendar',
                        crew: 'stat',
                    },
                    parentalPermissions: {
                        path: '/permissions',
                        crew: 'ptp',
                        subRoutes: {matrix: {path: '/matrix', crew: 'ptp'}},
                    },
                    periodPlans: {
                        path: '/periodPlans',
                        crew: 'ptp',
                        subRoutes: {group: {path: '/:childId', crew: 'ptp'}},
                    },
                    lists: {
                        path: '/lists',
                        crew: 'foundation',
                        subRoutes: {listFilter: {path: '/list-filter', crew: 'foundation'}},
                    },
                    institutionOverview: {
                        crew: 'foundation',
                        path: '/',
                    },
                    institutionOverviewOld: {
                        crew: 'foundation',
                        path: '/overview',
                    },
                    institutionOverviewParamerizedOld: {
                        path: '/overview/:type/:id/childrenAndStaff',
                        crew: 'foundation',
                    },
                    childrenAndStaff: {
                        crew: 'foundation',
                        path: '/:type/:id/childrenAndStaff',
                    },
                    subscription: {
                        crew: 'finance',
                        path: '/subscription',
                    },
                    mealPlan: {
                        path: '/mealPlan',
                        crew: 'ptp',
                        subRoutes: {
                            oldVersion: {
                                path: '/oldVersion',
                                crew: 'ptp',
                            },
                            createMealPlan: {
                                path: '/create',
                                crew: 'ptp',
                            },
                            viewMealPlan: {
                                path: '/:mealPlanId',
                                crew: 'ptp',
                            },
                        },
                    },
                    mealBooking: {
                        path: '/mealBooking',
                        crew: 'ptp',
                    },
                    customStatus: {
                        path: '/customStatus',
                        crew: 'foundation',
                    },
                    vacationPeriod: {
                        path: '/vacationPeriod/:vacationId',
                        crew: 'stat',
                    },
                    newDepartment: {
                        path: '/newDepartment',
                        crew: 'foundation',
                    },
                    vacationPlanning: {
                        path: '/vacationPlanning',
                        crew: 'stat',
                    },
                    info: {
                        path: '/info',
                        crew: 'foundation',
                    },
                    files: {
                        path: '/files',
                        crew: 'foundation',
                        subRoutes: {
                            parentDocuments: {
                                path: '/parentDocuments',
                                crew: 'foundation',
                            },
                        },
                    },
                    institutionSettings: {
                        path: '/institutionSettings',
                        crew: 'foundation',
                    },
                    manageGroups: {
                        path: '/manageGroups',
                        crew: 'foundation',
                    },
                    editTag: {
                        path: '/editTag/:tagId',
                        crew: 'foundation',
                    },
                    manageCheckinStatements: {
                        path: '/manageCheckinStatements',
                        crew: 'ptp',
                    },
                    volumePricingSettings: {
                        path: '/volumePricingSettings',
                        crew: 'finance',
                    },
                    mealSettings: {
                        path: '/mealSettings',
                        crew: 'ptp',
                    },
                    groupMoves: {
                        path: '/groupMoves',
                        crew: 'foundation',
                    },
                    billPayerV2: {
                        path: '/billPayer/:billPayerId',
                        crew: 'finance',
                        subRoutes: {
                            // This only exists for legacy reasons where backend notifications linked to this subroute.
                            // This will keep Ember happy.
                            paymentMethods: {path: '/paymentMethods', crew: 'finance'},
                            taxStatement: {
                                path: '/taxStatement/:selectedYear',
                                crew: 'finance',
                            },
                        },
                    },
                    // TODO: Is this used?
                    accountingSettings: {
                        path: '/accountingSettings',
                        crew: 'finance',
                    },
                    publicFundingReport: {
                        path: '/publicFundingReport',
                        crew: 'finance',
                    },
                    childBasedFundingReport: {
                        path: '/funding',
                        crew: 'finance',
                    },
                    staffing: {
                        path: '/staffing',
                        crew: 'stat',
                        subRoutes: {
                            attendance: {
                                path: '/attendance',
                                crew: 'stat',
                            },
                            attendanceDetails: {
                                path: '/attendance/details',
                                crew: 'stat',
                            },
                            shiftPlanner: {path: '/staffSchedule', crew: 'stat'},
                            staffHours: {path: '/staffHours', crew: 'stat'},
                            staffLeaveV2: {path: '/staffLeaveV2', crew: 'stat'},
                            staffRatioReport: {path: '/staffRatioReport', crew: 'stat'},
                        },
                    },
                    attendance: {
                        path: '/attendance',
                        crew: 'stat',
                        subRoutes: {
                            kinderConnect: {
                                path: '/kinderConnect',
                                crew: 'stat',
                                subRoutes: {
                                    month: {
                                        path: '/:yearMonth',
                                        crew: 'stat',
                                        subRoutes: {
                                            export: {
                                                path: '/export',
                                                crew: 'stat',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    billingProfiles: {
                        path: '/billingProfiles',
                        crew: 'finance',
                        subRoutes: {
                            attendanceSchedules: {
                                path: '/attendanceSchedules',
                                crew: 'finance',
                            },
                            fundingGrants: {path: '/fundingGrants', crew: 'finance'},
                        },
                    },
                    kitabuli: {
                        path: '/kitabuli',
                        crew: 'finance',
                    },
                    finance: {
                        path: '/finance',
                        crew: 'finance',
                    },
                    // TODO: Is this used?
                    financeReports: {
                        path: '/financeReports',
                        crew: 'finance',
                    },
                    invoiceSettings: {
                        path: '/invoiceSettings',
                        crew: 'finance',
                    },
                    discountSettings: {
                        path: '/discountSettings',
                        crew: 'finance',
                    },
                    // TODO: Is this used?
                    revenueAndDebt: {
                        path: '/revenueAndDebt',
                        crew: 'finance',
                    },
                    closingDays: {
                        path: '/closingDays',
                        crew: 'stat',
                    },
                    // TODO: Is this used?
                    revenueDetails: {
                        path: '/revenueDetails/:month',
                        crew: 'finance',
                    },
                    appReport: {
                        path: '/appReport',
                        crew: 'foundation',
                    },
                    manageAgeGroups: {
                        path: '/manageAgeGroups',
                        crew: 'stat', // TODO: Is this correct?
                    },
                    manageChildren: {
                        path: '/manageChildren',
                        crew: 'foundation',
                    },
                    paymentsSettings: {
                        path: '/paymentsSettings',
                        crew: 'finance',
                    },
                    fundingSettings: {
                        path: '/fundingSettings',
                        crew: 'finance',
                    },
                    revenueReport: {
                        path: '/revenueReport',
                        crew: 'finance',
                    },
                    debtReport: {
                        path: '/debtReport',
                        crew: 'finance',
                    },
                    debtCollection: {
                        path: '/debtCollection',
                        crew: 'payments',
                    },
                    payments: {
                        path: '/payments',
                        crew: 'finance',
                    },
                    invoicesReport: {
                        path: '/invoicesReport',
                        crew: 'finance',
                    },
                    billPayersReport: {
                        path: '/billPayersReport',
                        crew: 'finance',
                    },
                    depositsReport: {
                        path: '/depositsReport',
                        crew: 'finance',
                    },
                    directDebitsReport: {
                        path: '/directDebitsReport',
                        crew: 'finance',
                    },
                    // TODO: Get rid of this
                    apps: {
                        path: '/apps',
                        crew: 'foundation',
                    },
                    batchInvoice: {
                        path: '/batchInvoice',
                        crew: 'finance',
                    },
                    managePlans: {
                        path: '/managePlans',
                        crew: 'finance',
                    },
                    occupancyPlanner: {
                        path: '/occupancyPlanner',
                        crew: 'stat',
                    },
                    childDevelopment: {
                        path: '/childDevelopment',
                        crew: 'ptp',
                        subRoutes: {
                            progressReport: {path: '/progressReport', crew: 'ptp'},
                            cohortCompare: {path: '/cohortCompare', crew: 'ptp'},
                            nextSteps: {path: '/nextSteps', crew: 'ptp'},
                            twoYearChecks: {path: '/twoYearChecks', crew: 'ptp'},
                            tally: {path: '/tally', crew: 'ptp'},
                            groupObservation: {
                                path: '/groupObservation',
                                crew: 'ptp',
                            },
                        },
                    },
                    bookings: {
                        path: '/bookings',
                        crew: 'finance',
                        subRoutes: {
                            purchases: {path: '/purchases', crew: 'finance'},
                        },
                    },
                    bookingPatternBuilder: {
                        path: '/bookingPatternBuilder',
                        crew: 'finance',
                    },
                    bulkPatternFlow: {
                        path: '/bulkPatternFlow',
                        crew: 'finance',
                    },
                    roomPlanning: {
                        path: '/roomPlanning',
                        crew: 'stat',
                    },
                    inquiriesV2: {
                        path: '/inquiries',
                        crew: 'stat',
                    },
                    occupancyReport: {
                        path: '/occupancyReport',
                        crew: 'stat',
                    },
                    occupancy: {
                        path: '/occupancy',
                        crew: 'stat',
                    },
                    forms: {
                        path: '/forms',
                        crew: 'stat',
                        subRoutes: {
                            newForm: {
                                path: '/newForm',
                                crew: 'stat',
                            },
                            formBuilder: {
                                path: '/builder/:formId',
                                crew: 'stat',
                            },
                            customInquiryFormAuthenticated: {
                                path: '/submit/:formId/for/:childId',
                                crew: 'stat',
                            },
                            submissionResponse: {
                                path: '/:formId/submissionResponse/:submissionId',
                                crew: 'stat',
                            },
                            formManagement: {
                                path: '/management',
                                crew: 'stat',
                            },
                        },
                    },
                    billingActivityOverview: {
                        path: '/billingActivityOverview',
                        crew: 'finance',
                    },
                    attendanceStatistics: {
                        path: '/attendanceStatistics',
                        crew: 'stat',
                    },
                    // On the off-chance that people had made bookmarks for the new debt report
                    // we'll redirect back to the "normal" /debtReport route. At least for a while.
                    debtReportV2: {
                        path: '/debtReportV2',
                        crew: 'finance',
                    },
                    itemsAndPricing: {
                        path: '/itemsAndPricing',
                        crew: 'finance',
                    },
                    immunizations: {
                        path: '/immunizations',
                        crew: 'ptp',
                        subRoutes: {
                            onboarding: {
                                path: '/onboarding',
                                crew: 'ptp',
                            },
                        },
                    },
                    medicationForms: {
                        path: '/medicationForms',
                        crew: 'ptp',
                    },
                    famlyPay: {
                        path: '/famlyPay',
                        crew: 'finance',
                        subRoutes: {
                            payouts: {
                                path: '/payouts',
                                crew: 'finance',
                            },
                            fees: {
                                path: '/fees',
                                crew: 'finance',
                            },
                        },
                    },
                    bulkImportPayment: {
                        path: '/importPayments',
                        crew: 'finance',
                        subRoutes: {
                            splitPayments: {
                                path: '/splitPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                            protoPayments: {
                                path: '/protoPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                        },
                    },
                    headcount: {
                        path: '/headcount',
                        crew: 'ptp',
                    },
                    headcountReport: {
                        path: '/headcountReport',
                        crew: 'ptp',
                    },
                    editGroup: {
                        path: '/editGroup/:groupId',
                        crew: 'foundation',
                    },
                    healthAndSafeguarding: {
                        path: '/healthAndSafeguarding',
                        crew: 'ptp',
                        subRoutes: {
                            immunizations: {path: '/immunizations', crew: 'ptp'},
                            medicationForms: {path: '/medicationForms', crew: 'ptp'},
                            headcount: {path: '/headcount', crew: 'ptp'},
                        },
                    },
                    safeguarding: {
                        path: '/safeguarding',
                        crew: 'ptp',
                    },
                    openid: {
                        path: '/openid',
                        crew: 'foundation',
                        subRoutes: {
                            createProvider: {path: '/createProvider', crew: 'foundation'},
                        },
                    },
                    manageGroupRules: {
                        path: '/manageGroupRules',
                        crew: 'foundation',
                    },
                    lessonPlans: {path: '/lessonPlans', crew: 'ptp'},
                    curriculums: {
                        path: '/curriculums',
                        crew: 'ptp',
                        subRoutes: {
                            create: {
                                path: '/create',
                                crew: 'ptp',
                                subRoutes: {
                                    duplicate: {
                                        path: '/:curriculumId',
                                        crew: 'ptp',
                                    },
                                },
                            },
                            show: {
                                path: '/:curriculumId',
                                crew: 'ptp',
                            },
                        },
                    },
                    curriculumsList: {
                        path: '/curriculumsList',
                        crew: 'ptp',
                        subRoutes: {
                            show: {
                                path: '/:curriculumId',
                                crew: 'ptp',
                            },
                        },
                    },
                    manageEmployeeRights: {
                        path: '/manageEmployeeRights',
                        crew: 'foundation',
                        subRoutes: {
                            index: {path: '/', crew: 'foundation'},
                            roles: {path: '/roles', crew: 'foundation'},
                            permissions: {path: '/permissions', crew: 'foundation'},
                        },
                    },
                    employee: {
                        path: '/employee/:employeeId',
                        crew: 'stat',
                        subRoutes: {
                            employeeData: {
                                path: '/employeeData',
                                crew: 'stat',
                            },
                            employeeRelations: {
                                path: '/employeeRelations',
                                crew: 'stat',
                            },
                            employeeLeave: {
                                path: '/employeeLeave',
                                crew: 'stat',
                            },
                            about: {
                                path: '/about',
                                crew: 'stat',
                            },
                            employeeCalendar: {
                                path: '/employeeCalendar',
                                crew: 'stat',
                            },
                        },
                    },
                    childImport: {
                        path: '/childImport',
                        crew: 'ptp',
                    },
                    kitaImport: {
                        path: '/kitaImport',
                        crew: 'ptp',
                    },
                    kivanImport: {
                        path: '/kivanImport',
                        crew: 'foundation',
                    },
                    staff: {
                        path: '/staff',
                        crew: 'foundation', // TODO: is this correct?
                    },
                    children: {
                        path: '/children',
                        crew: 'foundation',
                    },
                    noAccess: {
                        path: '/noAccess',
                        crew: 'foundation',
                    },
                    financeOnboarding: {
                        path: '/financeOnboarding',
                        crew: 'growth',
                    },
                    /*
                        Since we added Famly Store to the institution routes, the link in the old nav was broken.
                        This was due to different way of handling routes and nav links in the old and new nav.
                        The solution is to keep both routes (at least for some time) until we are sure, nobody is on the old nav.
                    */
                    famlyStore: {
                        path: '/famlyStore',
                        subRoutes: {
                            packagePurchase: {
                                path: '/packagePurchase/:initialPackageId/:billingCycle',
                                crew: 'growth',
                            },
                            packagePricing: {
                                path: '/packagePricing',
                                crew: 'growth',
                            },
                            featureStore: {
                                path: '/featureStore',
                                crew: 'growth',
                            },
                            templates: {
                                path: '/templates',
                                crew: 'growth',
                            },
                        },
                        crew: 'growth',
                    },
                    contentReports: {
                        path: '/contentReports',
                        crew: 'foundation',
                    },
                    financeLandingPage: {
                        path: '/financeLandingPage',
                        crew: 'growth',
                    },
                    attendanceLandingPage: {
                        path: '/attendanceLandingPage',
                        crew: 'growth',
                    },
                    learningLandingPage: {
                        path: '/learningLandingPage',
                        crew: 'growth',
                    },
                    childrenLandingPage: {
                        path: '/childrenLandingPage',
                        crew: 'growth',
                    },
                },
            },
            /*
            |---------------------------------------------------------------------------------
            | Organization routes
            |---------------------------------------------------------------------------------
            */
            organization: {
                path: '/organization/:organizationId',
                crew: 'foundation',
                subRoutes: {
                    // TODO: Should we delete this? It doesn't work
                    home: {
                        path: '/home',
                        crew: 'foundation',
                    },
                    // TODO: Should we delete this? It doesn't work
                    homeCustomization: {
                        path: '/customization',
                        crew: 'foundation',
                    },
                    apiTokens: {
                        path: '/apiTokens',
                        crew: 'foundation',
                    },
                    security: {
                        path: '/security',
                        crew: 'foundation',
                    },
                    integrations: {
                        path: '/integrations',
                        crew: 'foundation',
                        subRoutes: {
                            watchMeGrow: {
                                path: '/watchMeGrow',
                                crew: 'ptp',
                            },
                        },
                    },
                    parentToDoLists: {
                        path: '/parentToDoLists',
                        crew: 'enr',
                        subRoutes: {
                            toDoList: {
                                path: '/list/:taskListId',
                                crew: 'enr',
                            },
                        },
                    },
                    openid: {
                        path: '/openid',
                        crew: 'foundation',
                        subRoutes: {
                            createProvider: {
                                path: '/createProvider',
                                crew: 'foundation',
                            },
                        },
                    },
                    inquiriesV2: {
                        path: '/inquiries',
                        crew: 'stat',
                    },
                    staffing: {
                        path: '/staffing',
                        crew: 'stat',
                        subRoutes: {
                            staffLeaveV2: {path: '/staffLeaveV2', crew: 'stat'},
                            staffHours: {
                                path: '/staffHours',
                                crew: 'stat',
                            },
                        },
                    },
                    settings: {
                        path: '/settings',
                        crew: 'foundation',
                    },
                    // TODO: Is this used?
                    subscription: {
                        path: '/subscription',
                        crew: 'finance',
                    },
                    // TODO: Is this used?
                    manageEmployees: {
                        path: '/manageEmployees',
                        crew: 'foundation', // TODO: Is this right?
                        subRoutes: {
                            overview: {
                                path: '/',
                                crew: 'foundation',
                            },
                            roles: {
                                path: '/roles',
                                crew: 'foundation',
                            },
                            permissions: {
                                path: '/permissions',
                                crew: 'foundation',
                            },
                        },
                    },
                    newArea: {
                        path: '/newArea',
                        crew: 'foundation',
                    },
                    revenueReport: {
                        path: '/revenueReport',
                        crew: 'finance',
                    },
                    billingActivityOverview: {
                        path: '/billingActivityOverview',
                        crew: 'finance',
                    },
                    payments: {
                        path: '/payments',
                        crew: 'finance',
                    },
                    invoicesReport: {
                        path: '/invoicesReport',
                        crew: 'finance',
                    },
                    billPayersReport: {
                        path: '/billPayersReport',
                        crew: 'finance',
                    },
                    directDebitsReport: {
                        path: '/directDebitsReport',
                        crew: 'finance',
                    },
                    occupancy: {
                        path: '/occupancy',
                        crew: 'stat',
                    },
                    occupancyReport: {
                        path: '/occupancyReport',
                        crew: 'stat',
                    },
                    publicFundingReport: {
                        path: '/publicFundingReport',
                        crew: 'finance',
                    },
                    balanceReport: {
                        path: '/balanceReport',
                        crew: 'finance',
                    },
                    insights: {
                        path: '/insights',
                        crew: 'foundation',
                    },
                    organizationOverview: {
                        path: '/',
                        crew: 'foundation',
                    },
                    dashboard: {
                        path: '/dashboard',
                        crew: 'foundation',
                    },
                    contentReports: {
                        path: '/contentReports',
                        crew: 'foundation',
                    },
                    // TODO: Is this used?
                    finance: {
                        path: '/finance',
                        crew: 'finance',
                    },
                    curriculums: {
                        path: '/curriculums',
                        crew: 'ptp',
                        subRoutes: {
                            create: {
                                path: '/create',
                                crew: 'ptp',
                                subRoutes: {
                                    duplicate: {
                                        path: '/:curriculumId',
                                        crew: 'ptp',
                                    },
                                },
                            },
                            show: {
                                path: '/:curriculumId',
                                crew: 'ptp',
                            },
                        },
                    },
                    curriculumsList: {
                        path: '/curriculumsList',
                        crew: 'ptp',
                        subRoutes: {
                            show: {
                                path: '/:curriculumId',
                                crew: 'ptp',
                            },
                        },
                    },
                    bulkImportPayment: {
                        path: '/importPayments',
                        crew: 'finance',
                        subRoutes: {
                            splitPayments: {
                                path: '/splitPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                            protoPayments: {
                                path: '/protoPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                        },
                    },
                },
            },
            loginAs: {
                path: '/loginAs',
                crew: 'foundation',
            },
            endpointDebugging: {
                path: '/endpointDebugging',
                crew: 'foundation',
            },
            financeDebugging: {
                path: '/financeDebugging',
                crew: 'finance',
                subRoutes: {
                    childId: {
                        path: '/:childId',
                        crew: 'finance',
                    },
                },
            },
            modernFamlyDebugging: {
                path: '/modernFamlyDebugging',
                crew: 'foundation',
            },
        },
    },
} as const satisfies RouteConfigType;

export default RouteConfig;
